import type { SeriesTime } from '@/versions/v1/schema/reading-series';

/** Named synthetic shape for the BM01 historian series. The outage itself is
 *  resolved by work order through DOWNTIME_STATES; the temperatures and noise
 *  below describe the synthetic operating response around that event. */
export const BM01_BEARING_SERIES_SHAPE = {
  name: 'trip-recovery-settle-wear-drift',
  trip: { workOrderId: 'WO-441' },
  startAt: '2026-05-25T06:00' as SeriesTime,
  startTemperatureC: 72,
  tripPeakTemperatureC: 92,
  restartTemperatureC: 74,
  settledTemperatureC: 78.5,
  settleEndAt: '2026-06-05T00:00' as SeriesTime,
  settleTauHours: 3,
  noiseSigmaC: 0.3,
  noisePhi: 0.6,
  provenance: '[syn] BM01 restart settles from 74 °C toward 78.5 °C; wear drift then reaches rd-bm-brg-temp at the cursor; hourly noise σ 0.3 °C',
} as const;

/** [syn] Case trigger parameters; warning and limit temperatures always come
 *  from rd-bm-brg-temp. The W3a probe independently applies this rule to the
 *  generated hourly series. */
export const BM01_BEARING_TRIGGER = {
  aboveWarningHours: 24,
  minimumPostRestartSlopeCPerDay: 0.5,
} as const;
